'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slugify = require('./slugify');

var _slugify2 = _interopRequireDefault(_slugify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slugify2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/slugify/index.js
// module id = 424
// module chunks = 11